export const ADMIN_RECEIPT_OPTIONS = [
  { lang: 'EN', format: 'jpeg', label: 'English JPEG' },
  { lang: 'EN', format: 'pdf', label: 'English PDF' },
  { lang: 'MR', format: 'jpeg', label: 'Marathi JPEG' },
  { lang: 'MR', format: 'pdf', label: 'Marathi PDF' },
  { lang: 'KN', format: 'jpeg', label: 'Kannada JPEG' },
  { lang: 'KN', format: 'pdf', label: 'Kannada PDF' },
];

export const ORDER_CREATION_RECEIPT_OPTIONS = ADMIN_RECEIPT_OPTIONS.filter(
  (option) => option.format === 'jpeg',
);
